import { createSelector } from 'reselect';
import { CampaignView } from './view/CampaignView';
import { getCampaigns } from './selector/getCampaigns';

export const OldCampaignsSelector = createSelector(
  [getCampaigns],
  (campaigns): Array<CampaignView> => {
    return campaigns
      .filter((item) => item.isClosed)
      .map(
        (item) =>
          new CampaignView({
            id: item.id,
            name: item.name,
            description: item.description,
            armyName: 'Army 2',
            logo: '/rails/active_storage/representations/redirect/eyJfcmFpbHMiOnsibWVzc2FnZSI6IkJBaHBBdHdIIiwiZXhwIjpudWxsLCJwdXIiOiJibG9iX2lkIn19--d2ddda63f89588ba7f98c2262a6e0ff921584e34/eyJfcmFpbHMiOnsibWVzc2FnZSI6IkJBaDdCem9MWm05eWJXRjBTU0lJY0c1bkJqb0dSVlE2RkhKbGMybDZaVjkwYjE5c2FXMXBkRnNIYVFISWFRSEkiLCJleHAiOm51bGwsInB1ciI6InZhcmlhdGlvbiJ9fQ==--372f1e54cf28d541eecb12eaeac1ad8e50f45d2f/Thumbbh.png',
          }),
      );
  },
);
